// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomSearchComponent_root__1Jw2E","input":"CustomSearchComponent_input__3Dgmb","iconButton":"CustomSearchComponent_iconButton__sa7_l"};